import { render, staticRenderFns } from "./DefaultAction.vue?vue&type=template&id=1c0d7f95&scoped=true"
import script from "./DefaultAction.vue?vue&type=script&lang=js"
export * from "./DefaultAction.vue?vue&type=script&lang=js"
import style0 from "./DefaultAction.vue?vue&type=style&index=0&id=1c0d7f95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0d7f95",
  null
  
)

export default component.exports